var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ModalThankYou.module.css';
import { addLog, logError } from 'utils/logs';
import { getRI } from 'services/clients/api/ri';
var StepState;
(function (StepState) {
    StepState[StepState["THANK_YOU"] = 0] = "THANK_YOU";
    StepState[StepState["APPOINTMENT"] = 1] = "APPOINTMENT";
})(StepState || (StepState = {}));
export default function ModalThankYou(_a) {
    var _this = this;
    var project = _a.project, lead = _a.lead, amount = _a.amount;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(StepState.THANK_YOU), step = _c[0], setStep = _c[1];
    var _d = useState(''), phoneCloser = _d[0], setPhoneCloser = _d[1];
    var t = useTranslation().t;
    var openCalendly = function (project) { return __awaiter(_this, void 0, void 0, function () {
        var ri_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    addLog("Click - openCalendly");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getRI(project.id, amount)];
                case 2:
                    ri_1 = (_a.sent()).data;
                    setTimeout(function () {
                        var _a;
                        setIsLoading(false);
                        // Construct the Full Name
                        var fullName = "".concat(lead.firstName || '', " ").concat(lead.lastName || '').trim();
                        var params = new URLSearchParams();
                        params.append('email', lead.email || '');
                        params.append('location', lead.phone || '');
                        params.append('name', fullName);
                        params.append('a1', project.name || '');
                        params.append('a2', project.name || '');
                        params.append('utm_source', 'LP');
                        params.append('utm_content', 'ri');
                        params.append('utm_medium', '');
                        params.append('utm_term', ((_a = project.id) === null || _a === void 0 ? void 0 : _a.toString()) || '');
                        var calendlyUrl = "".concat(ri_1.calendly, "?").concat(params.toString());
                        window.location.replace(calendlyUrl);
                    }, 1000);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    logError(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var takeNextAppointment = function (project) { return __awaiter(_this, void 0, void 0, function () {
        var ri, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    addLog("Click - takeNextAppointment", 'user-interaction', {
                        lead: {
                            projectId: project.id,
                            amount: amount,
                            email: lead.email,
                            firstName: lead.firstName,
                            lastName: lead.lastName,
                            phone: lead.phone,
                        }
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getRI(project.id, amount)];
                case 2:
                    ri = (_a.sent()).data;
                    setPhoneCloser(ri.number);
                    setStep(StepState.APPOINTMENT);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    logError(err_2);
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { className: styles.background, children: _jsxs("section", { className: styles.modal, children: [(step === StepState.THANK_YOU)
                    && (_jsxs(_Fragment, { children: [_jsx("h2", { children: t("modal.end.title") }), _jsx("p", { className: styles.description, children: t("modal.end.description.1") }), _jsx("p", { className: styles.description, children: t("modal.end.description.2") }), _jsxs("div", { className: styles['button-group'], children: [_jsx("button", { type: "button", "data-transaction-name": "takeNextAppointment", className: styles.button, onClick: function () { return takeNextAppointment(project); }, disabled: isLoading, children: isLoading
                                            ? _jsx("span", { className: "spinner" }) : (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.text, children: t("modal.end.button.1") }), _jsx(FontAwesomeIcon, { icon: "phone", className: styles.arrow })] })) }), _jsx("button", { type: "button", "data-transaction-name": "openCalendly", className: "".concat(styles.button, " primary"), onClick: function () { return openCalendly(project); }, disabled: isLoading, children: isLoading
                                            ? _jsx("span", { className: "spinner" }) : (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.text, children: t("modal.end.button.2") }), _jsx(FontAwesomeIcon, { icon: "calendar-days", className: styles.arrow })] })) })] })] })), (step === StepState.APPOINTMENT)
                    && (_jsxs(_Fragment, { children: [_jsx("p", { className: styles.description, children: t("modal.recall.title") }), _jsxs("p", { className: styles.description, children: [t("modal.recall.description"), " ", _jsx("b", { children: phoneCloser })] })] }))] }) }));
}
